var degToRadMult = Math.PI / 180;


module.exports = function(angle){
	return angle * degToRadMult;
};
